import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import { map } from "lodash"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Flatpickr from "react-flatpickr"
import notes from "../../assets/images/rsicons/notes.png";
import follow from "../../assets/images/rsicons/follow-up.png";
import phonelog from "../../assets/images/rsicons/phone-log.png";
import emaillog from "../../assets/images/rsicons/email-log.png";
import {
  Container, Row, Col, Card, CardBody, Label, FormGroup, Input, InputGroup,
  DropdownItem, DropdownMenu, DropdownToggle, Table, UncontrolledDropdown, Offcanvas, OffcanvasHeader, OffcanvasBody, Nav, NavItem, NavLink, TabPane, TabContent, CardTitle
} from "reactstrap"
import FilterMenu from "./filter-menu/filter-menu";
import {
  addLeadNoteTab, getLeads, getNoteLeadTab, getListLeadTab, addFollowNoteTab, getFollowLeadTab,
  getLeadCallLog, addLeadCallLog, addLeadEmailLog, getLeadEmailLog, getAllActLeadTab, deleteLead, addActivityFollowUp,
  getActivityFollowUp
} from "../../store/actions"
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import classnames from "classnames"
import CreateLead from './forms/lead-create'
import RsAdNew from "components/buttons/Adnew";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import moment from 'moment';
import AiButton from "components/buttons/aiBtn";
import SafeField from "helpers/SafeField";
class LeadList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      leads: [],
      lead: '',
      activeTab3: "2",
    }
    this.toggleAddNew = this.toggleAddNew.bind(this);

    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.isAllCanavas = this.isAllCanavas.bind(this);
    this.toggle3 = this.toggle3.bind(this);
  }
  handlePlaceSelected = (address, setFieldValue) => {
      geocodeByAddress(address)
        .then(results => {
          const place = results[0];
          const addressComponents = place.address_components;
          
          const getComponent = (types) => {
            const component = addressComponents.find((component) =>
              types.every((type) => component.types.includes(type))
            );
            return component ? component.long_name : '';
          };
          const latitude = place.geometry.location.lat();
          const longitude = place.geometry.location.lng();
          setFieldValue('activityLocation', place.formatted_address);
          setFieldValue('activityLatitude', longitude);
          setFieldValue('activityLongitude', latitude);
        })
        .catch(error => console.error('Error', error));
    };
  handleStartTime = (setFieldValue, values) => {
      const { startHrs, startMin, startDif } = values;
      const hours = parseInt(startHrs, 10);
      const minutes = parseInt(startMin, 10);
      const meridiem = startDif === 'PM' && hours < 12 ? hours + 12 : hours;
      const date = new Date();
      const formattedTime = moment()
        .set({ hour: meridiem, minute: minutes })
        .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
      setFieldValue('startTime', formattedTime);
  
    };
  
    handleEndTime = (setFieldValue, values) => {
      const { endHrs, endMin, endDif } = values;
      const hours = parseInt(endHrs, 10);
      const minutes = parseInt(endMin, 10);
      const meridiem = endDif === 'PM' && hours < 12 ? hours + 12 : hours;
      const date = new Date();
      const formattedTime = moment()
        .set({ hour: meridiem, minute: minutes })
        .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
      setFieldValue('endTime', formattedTime);
  
    };
  toggle3(tab) {
    if (this.state.activeTab3 !== tab) {
      this.setState({
        activeTab3: tab,
      });
    }
  }
  toggleAllCanavas() {
    this.setState(prevState => ({
      isAll: !prevState.isAll
    }));
  }
  isAllCanavas() {
    this.setState({ lead: "", isAll: !this.state.isAll });
    this.toggleAllCanavas();
  }
  isAllCanavas = arg => {
    const lead = arg;
    const { onGetFollowLead, onGetNoteLead, onGetLeadCallLog, onGetLeadEmailLog, onGetAllActLead } = this.props;
    this.setState({
      lead: {
        leadId: lead.id,
        contactName: lead.firstName+ " "+lead.lastName,
        email:lead.email,
        mobile:lead.mobile
      },
    });
    onGetFollowLead(lead.id);
    onGetNoteLead(lead.id);
    onGetLeadCallLog(lead.id);
    onGetLeadEmailLog(lead.id);
    onGetAllActLead(lead.id)
    this.toggleAllCanavas();
  };
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (lead) => {
    this.setState({ lead: lead });
    this.setState({ deleteModal: true });
  };

  handleDeleteLead = () => {
    const { onDeleteLead } = this.props;
    const { lead } = this.state;

    if (lead.id !== undefined) {
      onDeleteLead(lead);
      this.setState({ deleteModal: false });
    }
  };

  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));

  }

  addNewtoggle() {
    this.setState(prevState => ({
      isAddNew: !prevState.isAddNew
    }));
  }
  toggleAddNew() {
    this.setState({ isAddNew: !this.state.isAddNew });

  }

  componentDidMount() {
    const { onGetAllLeads } = this.props;
    onGetAllLeads(localStorage.getItem('userId'));
  }
  toggleEmailCanvas = arg => {
    const lead = arg;
    const { onGetAllActLead } = this.props;
    this.setState({
      lead: {
        id: lead.id,
      },
      isEdit: true,
    });
    onGetAllActLead(lead.id)
    this.toggle();
  };


  filterTable = (event) => {
    this.setState({ tableFilter: event.target.value });
  };

  handleInsertAi = (generatedText, setFieldValue) => {
    setFieldValue("addMessage", generatedText);
  };
  render() {
    const { onAddLeadNote, onAddLeadFollowUp, onAddCallLog, onAddEmailLog, onSendWorksheetEmailLog, allLeads, gridLoading } = this.props;
    const { leadNotes, leadFollows, calllogs, emaillogs, activities } = this.props;
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const lead = this.state.lead;
    const userModule = localStorage.getItem('userModule');
    const { isEdit, isEditFollow, isEditCall, isEditEmail, deleteModal } = this.state;
    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        {gridLoading ? (
          <div className="rs-loader-overlay">
            <div className="rs-loader"></div>
          </div>
        ) : null}
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteLead}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content project-page-content ">
          <MetaTags>
            <title>All Leads | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            <ToastContainer autoClose={2000} />
            <Row className="project-header">
              <Col xl="7">
                <Breadcrumbs
                  title={this.props.t("Lead")}
                  breadcrumbItem={this.props.t("All Leads")}
                />
              </Col>
              <Col xl="5">
                {/* <WelcomeComp /> */}
                <div className="pt-2 float-end mt-2">

                  <div className="">

                    <RsAdNew to="/lead/import-lead" className="btn btn-light btn-md me-2" iconClass="dripicons-download">Import Lead</RsAdNew>

                    <RsAdNew to="#" onClick={this.toggleAddNew} className="btn btn-light btn-md" iconClass="bx bx-plus-medical">Add New</RsAdNew>

                  </div>

                </div>
              </Col>
            </Row>
            <FilterMenu />
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>

                    <div className="row">

                      <div className="col-sm-4"></div>

                      <div className="col-sm-4 mb20">
                        <div className="input-group position-relative">
                          <Input
                            type="text"
                            className="form-control search-bx"
                            id="autoSizingInput"
                            value={this.state.tableFilter}
                            onInput={this.filterTable}
                            onChange={(e) => this.setState({ tableFilter: e.target.value })}
                            placeholder="Search By Name, Phone, Email"
                          />

                          {this.state.tableFilter && (
                            <button
                              className="btn btn-clear position-absolute"
                              style={{
                                right: "40px",
                                top: "48%",
                                transform: "translateY(-50%)",
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                              }}
                              onClick={() => this.setState({ tableFilter: "" })}
                            >
                              ✖
                            </button>
                          )}

                          <span className="input-group-text search-btn" id="basic-addon1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-search"
                              viewBox="0 0 16 16"
                            >
                              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                            </svg>
                          </span>
                        </div>

                      </div>


                    </div>
                    <div className="clearfix"></div>
                    <div className="datatable-loading">
                      <DataTable className="" stripedRows value={allLeads} paginator rows={10}
                        rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries "
                        paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown   "
                        tableStyle={{ minWidth: '50rem' }}
                        globalFilter={this.state.tableFilter}
                        rowClassName={(rowData) => rowData.onlyInterestedPreConsProject ? 'highlight-row' : ''}
                      >
                        <Column headerClassName="align-middle" body={(rowData) => (
                          <div className="form-check font-size-16">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={rowData.id}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={rowData.id}
                            >
                              &nbsp;
                            </label>
                          </div>

                        )}></Column>
                        <Column headerClassName="align-middle" bodyClassName="table-data" field="firstName" header="Name" body={(rowData) => (
                          <div className="row">
                            <div className="col-sm-10"><Link style={{ color: '#4c535a' }} to={"/lead/lead-detail/" + rowData.id + "/" + rowData.leadId}>{rowData.firstName} {rowData.lastName}</Link> </div>
                            <div className="col-sm-1 short-link"><Link className="link-open" to={"/lead/lead-detail/" + rowData.id + "/" + rowData.leadId}><i className="grid-icon bx bx-link-external"></i></Link></div>
                            <div className="col-sm-1 short-link"><Link onClick={() => this.isAllCanavas(rowData)} to="#"><i className="grid-icon bx bx-run"></i></Link></div>

                          </div>
                        )}></Column>
                        <Column field="mobile" header="Mobile"></Column>
                        <Column field="email" header="Email"></Column>
                        <Column field="lastContact" header="Last Contact" body={(rowData) => (
                          rowData.lastContact ? <Moment format="D MMM YY">{rowData.lastContact}</Moment> : ''
                        )}></Column>
                        <Column field="leadSourceId" header="Source" body={(rowData) => (
                          rowData.leadSourceId ? localization["LeadSource_" + rowData.leadSourceId] : 'N/A'
                        )}></Column>
                        <Column field="leadStatusId" header="Status" body={(rowData) => (
                          rowData.leadStatusId ? localization["LeadStatus_" + rowData.leadStatusId] : 'N/A'
                        )}></Column>
                        <Column header="Action" body={(rowData) => (
                          <>
                            <ActionEdit to={"/lead/lead-detail/" + rowData.id + "/" + rowData.leadId} />
                            {userModule.indexOf("BrokerAgent.RealtorLeads.Delete") > -1 ?
                              <ActionDelete onClick={() => this.onClickDelete(rowData)} />
                              : ''
                            }
                          </>
                        )}></Column>
                      </DataTable>
                      <Offcanvas
                        isOpen={this.state.isAll}
                        direction="end"
                        toggle={this.isAllCanavas}
                        style={{ width: 800 }}
                        s
                      >
                        <OffcanvasHeader className="submittedWorksheet" toggle={this.isAllCanavas}>
                          Activities
                        </OffcanvasHeader>
                        <OffcanvasBody>
                          <Nav pills className="navtab-bg nav-justified">
                          <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.activeTab3 === "2",
                                })}
                                onClick={() => {
                                  this.toggle3("2");
                                }}
                              >
                                All Activities
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.activeTab3 === "1",
                                })}
                                onClick={() => {
                                  this.toggle3("1");
                                }}
                              >
                                Follow Up
                              </NavLink>
                            </NavItem>
                          
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.activeTab3 === "3",
                                })}
                                onClick={() => {
                                  this.toggle3("3");
                                }}
                              >
                                Message
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.activeTab3 === "4",
                                })}
                                onClick={() => {
                                  this.toggle3("4");
                                }}
                              >
                                Add Notes
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.activeTab3 === "5",
                                })}
                                onClick={() => {
                                  this.toggle3("5");
                                }}
                              >
                                Call Log
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.activeTab3 === "6",
                                })}
                                onClick={() => {
                                  this.toggle3("6");
                                }}
                              >
                                Email Log
                              </NavLink>
                            </NavItem>
                          </Nav>
                          <TabContent
                            activeTab={this.state.activeTab3}
                            className="p-3 text-muted"
                          >
                            <TabPane tabId="1">
                             <Formik
                                          enableReinitialize={true}
                                          initialValues={{
                                            agentId:parseInt(localStorage.getItem("userId")),
                                            title:"Call log",
                                            contactname:lead.contactName,
                                            contactphone:lead.mobile,
                                            contactemail:lead.email,
                                            //addedDate: new Date(),
                                            activityStartDate: new Date(),
                                            startTime:"",
                                            endTime:"",
                                            activityStatus:1,
                                            activityType:3,
                                            activityRefId:lead.leadId,
                                            activityDescription: (this.state && this.state.activityDescription) || "",
                                            activityLocationType:3,
                                            activityLocation:"",
                                           
                                            isActive:true,
                                            category:3
                                          }}
                                          validationSchema={Yup.object().shape({
                                            activityDescription: Yup.string().required("This is Required")
                                          })}
                                          onSubmit={(values) => {
                                            const formattedValues = {
                                              ...values,
                                              activityStartDate: moment(values.activityStartDate).format('YYYY-MM-DD'),
                      
                                            };
                                            onAddLeadFollowUp(values)
                                            this.toggleAllCanavas();
                                         
                                            
                                        }}
                                        >
                                          {({ errors, touched, values, handleChange, setFieldValue }) => (
                                            <Form
                                              className="needs-validation"
                                            >
                            
                                              <Row>
                                                   <Col md="12">
                                                                      <FormGroup className="mb-3">
                                                                        <Label htmlFor="builderName">
                                                                          {this.props.t("Select Type")}
                                                                        </Label>
                                                                        <div className="clearfix"></div>
                                                                        <div className="btn-group" role="group">
                                                                          <SafeField type="radio" className="btn-check" 
                                                                          name="activityType" id="btnradio4" 
                                                                          value={3} 
                                                                          checked={values.activityType === 3} 
                                                                          onChange={() => {
                                                                            setFieldValue("activityType", 3)
                                                                            setFieldValue("title", "Call Log")
                                                                         }}
                                                                          autoComplete="off" />
                                                                          <label className="btn btn-outline-secondary" htmlFor="btnradio4">Call</label>
                                                
                                                                          <SafeField type="radio" className="btn-check"      name="activityType" id="btnradio5"  value={10} 
                                                                          checked={values.activityType === 10} 
                                                                         
                                                                          onChange={() => {
                                                                            setFieldValue("activityType", 1)
                                                                            setFieldValue("title", "Message")
                                                                         }}
                                                                          
                                                                          autoComplete="off" />
                                                                          <label className="btn btn-outline-secondary" htmlFor="btnradio5">Message</label>
                                                
                                                                          <SafeField type="radio" className="btn-check" name="activityType" id="btnradio6"  
                                                                          value={4} 
                                                                          checked={values.activityType === 4} 
                                                                        
                                                                          onChange={() => {
                                                                            setFieldValue("activityType", 4)
                                                                            setFieldValue("title", "Email")
                                                                         }}
                                                                          autoComplete="off" />
                                                                          <label className="btn btn-outline-secondary" htmlFor="btnradio6">Email</label>
                                                                         
                                                                           <SafeField type="radio" className="btn-check" name="activityType" id="btnradio7" value={1}
                                                                          checked={values.activityType === 1}
                                        
                                                                          onChange={() => {
                                                                            setFieldValue("activityType", 1)
                                                                            setFieldValue("title", "Meeting")
                                                                          }}
                                                                          
                                                                        autoComplete="off" />
                                                                        <label className="btn btn-outline-secondary" htmlFor="btnradio7">Meeting</label>
                                                                        </div>
                                                                        <ErrorMessage
                                                                          name="activityType"
                                                                          component="div"
                                                                          className="invalid-feedback"
                                                                        />
                                                                      </FormGroup>
                                                  </Col>
                                                <Col md="12">
                                                  <FormGroup className="mb-3">
                            
                                                    <textarea
                                                      name="activityDescription"
                                                      onChange={handleChange}
                                                      type="textarea"
                                                      className={
                                                        "form-control" +
                                                        (errors.activityDescription && touched.activityDescription
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      id="activityDescription"
                                                    />
                                                    <ErrorMessage
                                                      name="activityDescription"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </FormGroup>
                                                </Col>
                            
                                                <Col md="12">
                                                  <FormGroup className="mb15">
                            
                                                    <Label htmlFor="activityStartDate">
                                                      Date
                                                    </Label>
                                                    <Flatpickr
                                                      className={
                                                        "form-control" +
                                                        (errors.activityStartDate && touched.activityStartDate
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      placeholder=""
                                                      value={values.activityStartDate}
                                                      onChange={(value) => setFieldValue('activityStartDate', value[0])}
                                                      options={{
                                                        altInput: true,
                                                        altFormat: "F j, Y",
                                                        dateFormat: "Y-m-d"
                                                      }}
                                                    />
                                                    <ErrorMessage
                                                      name="logDate"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </FormGroup>
                            
                                                </Col>
                                                    { values.activityType === 1 && (
                                                                                            <>
                                                                                            <Col md="6">
                                                                                              <FormGroup className="mb-3">
                                                                                                <Label htmlFor="startTime">
                                                                                                  {this.props.t("Start Time")}
                                                                                                </Label>
                                                                                                <Row>
                                                                                                <Col md="4">
                                                                                            <SafeField
                                                                                                name="startHrs"
                                                                                                as="select"
                                                                                                
                                                                                                onChange={e => {
                                                                                                  handleChange(e);
                                                                                                  this.handleStartTime(setFieldValue, { ...values, startHrs: e.target.value });
                                                                                                }}
                                                                                                className={
                                                                                                    "form-control" +
                                                                                                    (errors.startHrs && touched.startHrs
                                                                                                    ? " is-invalid"
                                                                                                    : "")
                                                                                                }
                                                                                                id="hrs"
                                                                                                >
                                                                                                 <option value="">Hrs</option>
                                                                                                      {[...Array(12)].map((_, i) => (
                                                                                                        <option key={i + 1} value={i + 1} label={i + 1}>
                                                                                                          {i + 1}
                                                                                                        </option>
                                                                                                      ))}
                                                                                                </SafeField>
                                                                                                <ErrorMessage
                                                                                                  name="startHrs"
                                                                                                  component="div"
                                                                                                  className="invalid-feedback"
                                                                                                />
                                                                                            </Col>
                                                                                            <Col md="4">
                                                                                            <SafeField
                                                                                                name="startMin"
                                                                                                as="select"
                                                                                                
                                                                                                onChange={e => {
                                                                                                  handleChange(e);
                                                                                                  this.handleStartTime(setFieldValue, { ...values, startMin: e.target.value });
                                                                                                }}
                                                                                                className={
                                                                                                    "form-control" +
                                                                                                    (errors.startMin && touched.startMin
                                                                                                    ? " is-invalid"
                                                                                                    : "")
                                                                                                }
                                                                                                id="hrs"
                                                                                                >
                                                                                                 <option value="">Mins</option>
                                                                                                 {[0, 15, 30, 45].map((value) => (
                                                                                                  <option key={value} value={value}>
                                                                                                      {value === 0 ? '00' : value}
                                                                                                  </option>
                                                                                                ))}
                                                                                                </SafeField>
                                                                                                <ErrorMessage
                                                                                                  name="startMin"
                                                                                                  component="div"
                                                                                                  className="invalid-feedback"
                                                                                                />
                                                                                            </Col>
                                                                                            <Col md="4">
                                                                                            <SafeField
                                                                                                name="startDif"
                                                                                                as="select"
                                                                                                
                                                                                                onChange={e => {
                                                                                                  handleChange(e);
                                                                                                  this.handleStartTime(setFieldValue, { ...values, startDif: e.target.value });
                                                                                                }}
                                                                                                className={
                                                                                                    "form-control" +
                                                                                                    (errors.startDif && touched.startDif
                                                                                                    ? " is-invalid"
                                                                                                    : "")
                                                                                                }
                                                                                                id="hrs"
                                                                                                >
                                                                                                <option value='AM'>AM</option>
                                                                                                <option value='PM'>PM</option>
                                                                                                </SafeField>
                                                                                                <ErrorMessage
                                                                                                  name="startDif"
                                                                                                  component="div"
                                                                                                  className="invalid-feedback"
                                                                                                />
                                                                                            </Col>
                                                                                                </Row>
                                                                                              </FormGroup>
                                                                                            </Col>
                                                                        
                                                                                            <Col md="6">
                                                                                              <FormGroup className="mb-3">
                                                                                                <Label htmlFor="endTime">
                                                                                                  {this.props.t("End Time")}
                                                                                                </Label>
                                                                                                <Row>
                                                                                                <Col md="4">
                                                                                            <SafeField
                                                                                                name="endHrs"
                                                                                                as="select"
                                                                                                
                                                                                                onChange={e => {
                                                                                                  handleChange(e);
                                                                                                  this.handleEndTime(setFieldValue, { ...values, endHrs: e.target.value });
                                                                                                }}
                                                                                                className={
                                                                                                    "form-control" +
                                                                                                    (errors.endHrs && touched.endHrs
                                                                                                    ? " is-invalid"
                                                                                                    : "")
                                                                                                }
                                                                                                id="hrs"
                                                                                                >
                                                                                                 <option value="">Hrs</option>
                                                                                                      {[...Array(12)].map((_, i) => (
                                                                                                        <option key={i + 1} value={i + 1} label={i + 1}>
                                                                                                          {i + 1}
                                                                                                        </option>
                                                                                                      ))}
                                                                                                </SafeField>
                                                                                                <ErrorMessage
                                                                                                  name="endHrs"
                                                                                                  component="div"
                                                                                                  className="invalid-feedback"
                                                                                                />
                                                                                            </Col>
                                                                                            <Col md="4">
                                                                                            <SafeField
                                                                                                name="endMin"
                                                                                                as="select"
                                                                                                
                                                                                                onChange={e => {
                                                                                                  handleChange(e);
                                                                                                  this.handleEndTime(setFieldValue, { ...values, endHrs: e.target.value });
                                                                                                }}
                                                                                                className={
                                                                                                    "form-control" +
                                                                                                    (errors.endMin && touched.endMin
                                                                                                    ? " is-invalid"
                                                                                                    : "")
                                                                                                }
                                                                                                id="hrs"
                                                                                                >
                                                                                                 <option value="">Mins</option>
                                                                                                 {[0, 15, 30, 45].map((value) => (
                                                                                                  <option key={value} value={value}>
                                                                                                      {value === 0 ? '00' : value}
                                                                                                  </option>
                                                                                                ))}
                                                                                                </SafeField>
                                                                                                <ErrorMessage
                                                                                                  name="endMin"
                                                                                                  component="div"
                                                                                                  className="invalid-feedback"
                                                                                                />
                                                                                            </Col>
                                                                                            <Col md="4">
                                                                                            <SafeField
                                                                                                name="endDif"
                                                                                                as="select"
                                                                                                
                                                                                                onChange={e => {
                                                                                                  handleChange(e);
                                                                                                  this.handleEndTime(setFieldValue, { ...values, endDif: e.target.value });
                                                                                                }}
                                                                                                className={
                                                                                                    "form-control" +
                                                                                                    (errors.endDif && touched.endDif
                                                                                                    ? " is-invalid"
                                                                                                    : "")
                                                                                                }
                                                                                                id="hrs"
                                                                                                >
                                                                                                <option value='AM'>AM</option>
                                                                                                <option value='PM'>PM</option>
                                                                                                </SafeField>
                                                                                                <ErrorMessage
                                                                                                  name="endDif"
                                                                                                  component="div"
                                                                                                  className="invalid-feedback"
                                                                                                />
                                                                                            </Col>
                                                                                                </Row>
                                                                                              </FormGroup>
                                                                                            </Col>
                                                                                             <Col md="12">
                                                                                                                  <FormGroup className="mb-3">
                                                                                                                    <Label htmlFor="notes">
                                                                                                                      {this.props.t("Location")}
                                                                                                                    </Label>
                                                                                                                    <div className="clearfix"></div>
                                                                                                                    <div className="btn-group" role="group">
                                                                                            
                                                                                                                      <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio9" value={3} autoComplete="off" />
                                                                                                                      <label className="btn btn-outline-secondary" htmlFor="btnradio9">In-person</label>
                                                                                                                      <SafeField type="radio" className="btn-check" name="activityLocationType" id="btnradio10" value={1} autoComplete="off" />
                                                                                                                      <label className="btn btn-outline-secondary" htmlFor="btnradio10">Online</label>
                                                                                                                    </div>
                                                                                            
                                                                                                                  </FormGroup>
                                                                                                                </Col>
                                                                                            
                                                                                                                <Col md="12">
                                                                                                                  <FormGroup className="mb-3">
                                                                                                                    <Label htmlFor="addressLine1">
                                                                                                                      {this.props.t("Location")}
                                                                                                                    </Label>
                                                                                                                    {values.activityLocationType === 3 ? (
                                                                                                                    <PlacesAutocomplete
                                                                                                                      value={values.activityLocation}
                                                                                                                      onChange={(value) => setFieldValue('activityLocation', value)}
                                                                                                                      onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                                                                                                    >
                                                                                                                      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                                                                                        <div>
                                                                                                                          <input
                                                                                                                            {...getInputProps({
                                                                                                                              placeholder: 'Enter Address...',
                                                                                                                              className: 'form-control',
                                                                                            
                                                                                                                            })}
                                                                                                                          />
                                                                                                                          <div className="">
                                                                                                                            {loading ? <div>Loading...</div> : null}
                                                                                            
                                                                                                                            {suggestions.map((suggestion, i) => {
                                                                                                                              const className = suggestion.active
                                                                                                                                ? 'suggestion-item--active'
                                                                                                                                : 'suggestion-item';
                                                                                                                              const style = suggestion.active
                                                                                                                                ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                                                                                                : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };
                                                                                            
                                                                                                                              return (
                                                                                                                                <div
                                                                                                                                  key={i}
                                                                                                                                  {...getSuggestionItemProps(suggestion, {
                                                                                                                                    style,
                                                                                                                                  })}
                                                                                                                                >
                                                                                                                                  {suggestion.description}
                                                                                                                                </div>
                                                                                                                              );
                                                                                                                            })}
                                                                                                                          </div>
                                                                                                                        </div>
                                                                                                                      )}
                                                                                                                    </PlacesAutocomplete>
                                                                                                                    ) : (
                                                                                                                      <SafeField
                                                                                                                      name="activityLocation"
                                                                                                                      onChange={handleChange}                            
                                                                                                                      type="text"
                                                                                                                      className={
                                                                                                                        "form-control" +
                                                                                                                        (errors.activityLocation && touched.activityLocation
                                                                                                                          ? " is-invalid"
                                                                                                                          : "")
                                                                                                                      }
                                                                                                                      id="activityLocation"
                                                                                                                      
                                                                                                                    /> 
                                                                                                                    )}
                                                                                                                  </FormGroup>
                                                                                                                </Col>
                                                                                            </>
                                                                                            )}
                                              </Row>
                            
                                              <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>
                            
                            
                                            </Form>
                                          )}
                                        </Formik>

                                        <div className="mb-5 h4 card-title mt-20">Follow-up History</div>
                                <ul className="verti-timeline list-unstyled">

                                  {map(leadFollows, (follLog, follLogkey) => (

                                    <li className="event-list eventlist" key={"_note_" + follLogkey}>
                                      <div className="event-timeline-dot">
                                        <i className="bx bx-right-arrow-circle font-size-18" />
                                      </div>
                                      <div className="d-flex">
                                        <div className="flex-shrink-0 me-3">
                                          <h5 className="font-size-14">
                                            <Moment format="D MMM YY">{follLog.activityStartDate	}</Moment>


                                          </h5>
                                        </div>
                                        <div className="flex-grow-1">
                                          <h5 className="font-size-14"></h5>
                                        </div>
                                      </div>
                                      <div className="exNote">{follLog.displayTitle	}</div>
                                    </li>
                                  ))}

                                </ul>

                              
                            </TabPane>
                            <TabPane tabId="2">
                              <div className="tabContent">
                                <ul className="verti-timeline list-unstyled">
                                  {map(
                                    activities,
                                    (allactivity, allactkey) => (
                                      <li
                                        className="event-list eventlist"
                                        key={"_allact_" + allactkey}
                                      >
                                        <div className="event-timeline-dot">
                                          {(() => {
                                            if (
                                              allactivity.activitySubType ==
                                              8 ||
                                              allactivity.activitySubType ==
                                              9 ||
                                              allactivity.activitySubType ==
                                              7
                                            ) {
                                              return (
                                                <>
                                                  <img src={emaillog} />
                                                </>
                                              );
                                            } else if (
                                              allactivity.activitySubType ==
                                              3 ||
                                              allactivity.activitySubType ==
                                              4 ||
                                              allactivity.activitySubType ==
                                              5
                                            ) {
                                              return (
                                                <>
                                                  <img src={phonelog} />
                                                </>
                                              );
                                            } else if (
                                              allactivity.activitySubType ==
                                              10
                                            ) {
                                              return (
                                                <>
                                                  <img src={follow} />
                                                </>
                                              );
                                            } else {
                                              return (
                                                <>
                                                  <img src={notes} />
                                                </>
                                              );
                                            }
                                          })()}
                                        </div>
                                        <div className="d-flex">
                                          <div className="flex-shrink-0 me-3">
                                            <h5 className="font-size-14">
                                              <Moment format="D MMM YY">
                                                {allactivity.addedDate}
                                              </Moment>
                                            </h5>
                                          </div>
                                          <div className="flex-grow-1">
                                            <h5 className="font-size-14">
                                              {
                                                localization[
                                                "ActivitySubType_" +
                                                allactivity.activityType +
                                                "_" +
                                                allactivity.activitySubType
                                                ]
                                              }
                                            </h5>
                                          </div>
                                        </div>
                                        <div className="exNote">
                                          {allactivity.activityRemarks}
                                        </div>
                                      </li>
                                    )
                                  )}
                                </ul>
                              </div>
                            </TabPane>

                            <TabPane tabId="3">
                              <div className="tabContent">
                                <Formik
                                  enableReinitialize={true}
                                  initialValues={{

                                    //refId: lead.leadId,
                                    addMessage: (this.state && this.state.addMessage) || "",



                                  }}
                                  validationSchema={Yup.object().shape({
                                    addMessage: Yup.string().required("This is Required")
                                  })}

                                  onSubmit=""
                                >
                                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                                    <Form
                                      className="needs-validation"
                                    >

                                      <Row>
                                        <Col md="12">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="addNote" className="w-100">
                                              {this.props.t("Send Message")}
                                              <span className="float-end"> <AiButton onInsert={(text) => this.handleInsertAi(text, setFieldValue)} /> </span>
                                            </Label>
                                            <SafeField
                                              name="addMessage"
                                              onChange={handleChange}
                                              as="textarea"
                                              className={
                                                "form-control" +
                                                (errors.addMessage && touched.addMessage
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              id="addMessage"
                                            />
                                            <ErrorMessage
                                              name="addMessage"
                                              component="div"
                                              className="invalid-feedback"
                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Send")}</button></div>


                                    </Form>
                                  )}
                                </Formik>
                                <div className="mb-5 h4 card-title mt-20">Message History</div>
                              </div>
                            </TabPane>
                            <TabPane tabId="4">
                              <div className="tabContent">
                                <Formik
                                  enableReinitialize={true}
                                  initialValues={{

                                    refId: lead.leadId,
                                    addNote: (this.state && this.state.addNote) || "",



                                  }}
                                  validationSchema={Yup.object().shape({
                                    addNote: Yup.string().required("This is Required")
                                  })}

                                  onSubmit={values => {
                                    onAddLeadNote(values)
                                    this.toggleAllCanavas();
                                  }}
                                >
                                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                                    <Form
                                      className="needs-validation"
                                    >

                                      <Row>
                                        <Col md="12">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="addNote">
                                              {this.props.t("Add Note")}
                                            </Label>
                                            <textarea
                                              name="addNote"
                                              onChange={handleChange}
                                              type="textarea"
                                              className={
                                                "form-control" +
                                                (errors.addNote && touched.addNote
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              id="addNote"
                                            />
                                            <ErrorMessage
                                              name="addNote"
                                              component="div"
                                              className="invalid-feedback"
                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Save")}</button></div>


                                    </Form>
                                  )}
                                </Formik>
                                <div className="mb-5 h4 card-title mt-20">Notes History</div>
                                <ul className="verti-timeline list-unstyled">

                                  {map(leadNotes, (noteLog, notekey) => (

                                    <li className="event-list eventlist" key={"_note_" + notekey}>
                                      <div className="event-timeline-dot">
                                        <i className="bx bx-right-arrow-circle font-size-18" />
                                      </div>
                                      <div className="d-flex">
                                        <div className="flex-shrink-0 me-3">
                                          <h5 className="font-size-14">
                                            <Moment format="D MMM YY">{noteLog.addedDate}</Moment>


                                          </h5>
                                        </div>
                                        <div className="flex-grow-1">
                                          <h5 className="font-size-14"></h5>
                                        </div>
                                      </div>
                                      <div className="exNote">{noteLog.activityRemarks}</div>
                                    </li>
                                  ))}

                                </ul>
                              </div>
                            </TabPane>
                            <TabPane tabId="5">
                              <div className="tabContent">
                                <Formik
                                  enableReinitialize={true}
                                  initialValues={{
                                    actionType: '',
                                    addedDate: new Date(),
                                    refId: lead.leadId,
                                    callNote: ''


                                  }}
                                  validationSchema={Yup.object().shape({
                                    actionType: Yup.string().required(
                                      "Please Select Action"
                                    ),
                                    callNote: Yup.string().required(
                                      "Enter Note"
                                    ),
                                  })}

                                  onSubmit={values => {
                                    onAddCallLog(values)
                                    this.toggleAllCanavas();
                                  }}
                                >
                                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                                    <Form
                                      className="needs-validation"
                                    >

                                      <Row className="mt20 mb20">



                                        <Col lg="12">
                                          <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                                            <label>
                                              <SafeField type="radio" name="actionType" id="actionType1" value="No Answer" onChange={handleChange} />
                                              No Answer
                                            </label>
                                            <label>
                                              <SafeField type="radio" name="actionType" id="actionType2" value="Left Voicemail" onChange={handleChange} />
                                              Left Voicemail
                                            </label>
                                            <label>
                                              <SafeField type="radio" name="actionType" id="actionType2" value="Bad Number" onChange={handleChange} />
                                              Bad Number
                                            </label>

                                          </div>
                                          <ErrorMessage
                                            name="actionType"
                                            component="div"
                                            className="invalid-feedback"
                                          />

                                        </Col>

                                      </Row>
                                      <Row>
                                        <Col md="12">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="addedDate">
                                              Log Date
                                            </Label>
                                            <Flatpickr
                                              className={
                                                "form-control" +
                                                (errors.addedDate && touched.addedDate
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              placeholder=""
                                              value={values.addedDate}
                                              onChange={(value) => setFieldValue('addedDate', value[0])}
                                              options={{
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                dateFormat: "Y-m-d"
                                              }}
                                            />
                                            <ErrorMessage
                                              name="addedDate"
                                              component="div"
                                              className="invalid-feedback"
                                            />

                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col md="12">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="callNote">
                                              Add Message
                                            </Label>
                                            <SafeField
                                              name="callNote"
                                              onChange={handleChange}
                                              as="textarea"

                                              className="form-control"

                                              id="callNote"

                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                                    </Form>
                                  )}
                                </Formik>
                                <div className="mb-5 h4 card-title mt-20">Call Log History</div>
                                <ul className="verti-timeline list-unstyled">

                                  {map(calllogs, (callLog, callkey) => (

                                    <li className="event-list eventlist" key={"_call_" + callkey}>
                                      <div className="event-timeline-dot">
                                        <i className="bx bx-right-arrow-circle font-size-18" />
                                      </div>
                                      <div className="d-flex">
                                        <div className="flex-shrink-0 me-3">
                                          <h5 className="font-size-14">
                                            <Moment format="D MMM YY">{callLog.addedDate}</Moment>

                                            <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                                          </h5>
                                        </div>
                                        <div className="flex-grow-1">
                                          <h5 className="font-size-14">{localization["ActivitySubType_" + callLog.activityType + "_" + callLog.activitySubType]}</h5>
                                        </div>
                                      </div>
                                      <div className="exNote">{callLog.activityRemarks}</div>
                                    </li>
                                  ))}

                                </ul>
                              </div>
                            </TabPane>
                            <TabPane tabId="6">
                              <div className="tabContent">
                                <Formik
                                  enableReinitialize={true}
                                  initialValues={{
                                    actionType: '',
                                    addedDate: new Date(),
                                    refId: lead.leadId

                                  }}
                                  validationSchema={Yup.object().shape({
                                    actionType: Yup.string().required(
                                      "Please Select Action"
                                    )
                                  })}

                                  onSubmit={values => {
                                    onAddEmailLog(values)
                                    this.toggleAllCanavas();
                                  }}
                                >
                                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                                    <Form
                                      className="needs-validation"
                                    >

                                      <Row className="mt20 mb20">



                                        <Col lg="12">
                                          <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                                            <label>
                                              <SafeField type="radio" name="actionType" id="actionType1" value="Email Sent" onChange={handleChange} />
                                              Email Sent
                                            </label>
                                            <label>
                                              <SafeField type="radio" name="actionType" id="actionType2" value="Email Received" onChange={handleChange} />
                                              Email Received
                                            </label>
                                            <label>
                                              <SafeField type="radio" name="actionType" id="actionType2" value="Email Bounced" onChange={handleChange} />
                                              Email Bounced
                                            </label>

                                          </div>
                                          <ErrorMessage
                                            name="actionType"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </Col>

                                      </Row>
                                      <Row>
                                        <Col md="12">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="addedDate">
                                              Log Date
                                            </Label>
                                            <Flatpickr
                                              className={
                                                "form-control" +
                                                (errors.addedDate && touched.addedDate
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              placeholder=""
                                              value={values.addedDate}
                                              onChange={(value) => setFieldValue('addedDate', value[0])}
                                              options={{
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                dateFormat: "Y-m-d"
                                              }}
                                            />
                                            <ErrorMessage
                                              name="addedDate"
                                              component="div"
                                              className="invalid-feedback"
                                            />

                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col md="12">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="remarks">
                                              Add Message
                                            </Label>
                                            <SafeField
                                              name="remarks"
                                              onChange={handleChange}
                                              as="textarea"

                                              className="form-control"

                                              id="remarks"

                                            />
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                                    </Form>
                                  )}
                                </Formik>
                                <div className="mb-5 h4 card-title mt-20">Email Log History</div>
                                <ul className="verti-timeline list-unstyled">

                                  {map(emaillogs, (emailLog, emailkey) => (

                                    <li className="event-list eventlist" key={"_email_" + emailkey}>
                                      <div className="event-timeline-dot">
                                        <i className="bx bx-right-arrow-circle font-size-18" />
                                      </div>
                                      <div className="d-flex">
                                        <div className="flex-shrink-0 me-3">
                                          <h5 className="font-size-14">
                                            <Moment format="D MMM YY">{emailLog.addedDate}</Moment>

                                            <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                                          </h5>
                                        </div>
                                        <div className="flex-grow-1">
                                          <h5 className="font-size-14">{localization["ActivitySubType_" + emailLog.activityType + "_" + emailLog.activitySubType]}</h5>
                                        </div>
                                      </div>
                                      <div className="exNote">{emailLog.activityRemarks}</div>
                                    </li>
                                  ))}

                                </ul>
                              </div>
                            </TabPane>
                          </TabContent>



                        </OffcanvasBody>
                      </Offcanvas>

                      <Offcanvas
                        isOpen={this.state.isAddNew}
                        direction="end"
                        toggle={this.toggleAddNew}
                        style={{ width: 800 }}
                      >
                        <OffcanvasHeader toggle={this.toggleAddNew}>
                          New Lead
                        </OffcanvasHeader>
                        <OffcanvasBody>
                          <CreateLead toggleAddNew={this.toggleAddNew} />
                        </OffcanvasBody>
                      </Offcanvas>
                      <Offcanvas
                        isOpen={this.state.isRight}
                        direction="end"
                        toggle={this.toggleEmailCanvas}

                      >
                        <OffcanvasHeader toggle={this.toggleEmailCanvas}>
                          All Activities
                        </OffcanvasHeader>
                        <OffcanvasBody>
                          <ul className="verti-timeline list-unstyled">
                            {map(
                              activities,
                              (allactivity, allactkey) => (
                                <li
                                  className="event-list eventlist"
                                  key={"_allact_" + allactkey}
                                >
                                  <div className="event-timeline-dot">
                                    {(() => {
                                      if (
                                        allactivity.activitySubType ==
                                        8 ||
                                        allactivity.activitySubType ==
                                        9 ||
                                        allactivity.activitySubType ==
                                        7
                                      ) {
                                        return (
                                          <>
                                            <img src={emaillog} />
                                          </>
                                        );
                                      } else if (
                                        allactivity.activitySubType ==
                                        3 ||
                                        allactivity.activitySubType ==
                                        4 ||
                                        allactivity.activitySubType ==
                                        5
                                      ) {
                                        return (
                                          <>
                                            <img src={phonelog} />
                                          </>
                                        );
                                      } else if (
                                        allactivity.activitySubType ==
                                        10
                                      ) {
                                        return (
                                          <>
                                            <img src={follow} />
                                          </>
                                        );
                                      } else {
                                        return (
                                          <>
                                            <img src={notes} />
                                          </>
                                        );
                                      }
                                    })()}
                                  </div>
                                  <div className="d-flex">
                                    <div className="flex-shrink-0 me-3">
                                      <h5 className="font-size-14">
                                        <Moment format="D MMM YY">
                                          {allactivity.addedDate}
                                        </Moment>
                                      </h5>
                                    </div>
                                    <div className="flex-grow-1">
                                      <h5 className="font-size-14">
                                        {
                                          localization[
                                          "ActivitySubType_" +
                                          allactivity.activityType +
                                          "_" +
                                          allactivity.activitySubType
                                          ]
                                        }
                                      </h5>
                                    </div>
                                  </div>
                                  <div className="exNote">
                                    {allactivity.activityRemarks}
                                  </div>
                                </li>
                              )
                            )}
                          </ul>
                        </OffcanvasBody>
                      </Offcanvas>

                      <Offcanvas
                        isOpen={this.state.isAddNote}
                        direction="end"
                        toggle={this.toggleAddNoteCanvas}
                      >
                        <OffcanvasHeader toggle={this.toggleAddNoteCanvas}>
                          Add Notes
                        </OffcanvasHeader>
                        <OffcanvasBody>
                          <Formik
                            enableReinitialize={true}
                            initialValues={{

                              refId: lead.id,
                              addNote: (this.state && this.state.addNote) || "",



                            }}
                            validationSchema={Yup.object().shape({
                              // addNote: Yup.string().required("This is Required"),
                              addNote: Yup.string().max(500, 'This filed contains only 500 characters only').required("This is Required")
                            })}

                            onSubmit={values => {

                              if (isEdit) {

                                onAddLeadNote(values)
                                //onAddLeadNote(updateData);
                              } else {

                              }
                              
                              this.toggleAddNote();
                            }}
                          >
                            {({ errors, touched, values, handleChange, setFieldValue }) => (
                              <Form
                                className="needs-validation"
                              >

                                <Row>
                                  <Col md="12">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="addNote">
                                        {this.props.t("Add Note")}
                                      </Label>
                                      <textarea
                                        name="addNote"
                                        onChange={handleChange}
                                        type="textarea"
                                        className={
                                          "form-control" +
                                          (errors.addNote && touched.addNote
                                            ? " is-invalid"
                                            : "")
                                        }
                                        id="addNote"
                                      />
                                      <ErrorMessage
                                        name="addNote"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Save")}</button></div>


                              </Form>
                            )}
                          </Formik>
                          <div className="mb-5 h4 card-title mt-20">Notes History</div>
                          <ul className="verti-timeline list-unstyled">

                            {map(leadNotes, (noteLog, notekey) => (

                              <li className="event-list eventlist" key={"_note_" + notekey}>
                                <div className="event-timeline-dot">
                                  <i className="bx bx-right-arrow-circle font-size-18" />
                                </div>
                                <div className="d-flex">
                                  <div className="flex-shrink-0 me-3">
                                    <h5 className="font-size-14">
                                      <Moment format="D MMM YY">{noteLog.addedDate}</Moment>


                                    </h5>
                                  </div>
                                  <div className="flex-grow-1">
                                    <h5 className="font-size-14"></h5>
                                  </div>
                                </div>
                                <div className="exNote">{noteLog.activityRemarks}</div>
                              </li>
                            ))}

                          </ul>
                        </OffcanvasBody>
                      </Offcanvas>

                      <Offcanvas
                        isOpen={this.state.isCallLog}
                        direction="end"
                        toggle={this.toggleCallLogCanvas}
                        style={{ width: 800 }}
                      >
                        <OffcanvasHeader toggle={this.toggleCallLogCanvas}>
                          Call Log
                        </OffcanvasHeader>
                        <OffcanvasBody>
                          <Formik
                            enableReinitialize={true}
                            initialValues={{
                              actionType: '',
                              addedDate: new Date(),
                              refId: lead.id
                              // callNote: (this.state && this.state.callNote) || "",


                            }}
                            validationSchema={Yup.object().shape({
                              actionType: Yup.string().required(
                                "Please Select Action"
                              ),
                              callNote: Yup.string().max(500, 'This filed contains only 500 characters only')
                            })}

                            onSubmit={values => {

                              if (isEditCall) {

                                onAddCallLog(values)
                                //onAddLeadNote(updateData);
                              } else {

                              }
                              this.toggleCallLog();
                            }}
                          >
                            {({ errors, touched, values, handleChange, setFieldValue }) => (
                              <Form
                                className="needs-validation"
                              >

                                <Row className="mt20 mb20">



                                  <Col lg="12">
                                    <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                                      <label>
                                        <SafeField type="radio" name="actionType" id="actionType1" value="No Answer" onChange={handleChange} />
                                        No Answer
                                      </label>
                                      <label>
                                        <SafeField type="radio" name="actionType" id="actionType2" value="Left Voicemail" onChange={handleChange} />
                                        Left Voicemail
                                      </label>
                                      <label>
                                        <SafeField type="radio" name="actionType" id="actionType2" value="Bad Number" onChange={handleChange} />
                                        Bad Number
                                      </label>
                                      <ErrorMessage
                                        name="actionType"
                                        component="div"
                                        className="text-danger"
                                      />

                                    </div>


                                  </Col>

                                </Row>
                                <Row>
                                  <Col md="12">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="addedDate">
                                        Log Date
                                      </Label>
                                      <Flatpickr
                                        className={
                                          "form-control" +
                                          (errors.addedDate && touched.addedDate
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder=""
                                        value={values.addedDate}
                                        onChange={(value) => setFieldValue('addedDate', value[0])}
                                        options={{
                                          altInput: true,
                                          altFormat: "F j, Y",
                                          dateFormat: "Y-m-d"
                                        }}
                                      />
                                      <ErrorMessage
                                        name="addedDate"
                                        component="div"
                                        className="invalid-feedback"
                                      />

                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md="12">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="callNote">
                                        Add Message (Optional)
                                      </Label>
                                      <textarea
                                        name="callNote"
                                        onChange={handleChange}
                                        type="textarea"

                                        className={
                                          "form-control" +
                                          (errors.callNote && touched.callNote
                                            ? " is-invalid"
                                            : "")
                                        }

                                        id="callNote"

                                      />
                                      <ErrorMessage
                                        name="callNote"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                              </Form>
                            )}
                          </Formik>
                          <div className="mb-5 h4 card-title mt-20">Call Log History</div>
                          <ul className="verti-timeline list-unstyled">

                            {map(calllogs, (callLog, callkey) => (

                              <li className="event-list eventlist" key={"_call_" + callkey}>
                                <div className="event-timeline-dot">
                                  <i className="bx bx-right-arrow-circle font-size-18" />
                                </div>
                                <div className="d-flex">
                                  <div className="flex-shrink-0 me-3">
                                    <h5 className="font-size-14">
                                      <Moment format="D MMM YY">{callLog.addedDate}</Moment>

                                      <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                                    </h5>
                                  </div>
                                  <div className="flex-grow-1">
                                    <h5 className="font-size-14">{localization["ActivitySubType_" + callLog.activityType + "_" + callLog.activitySubType]}</h5>
                                  </div>
                                </div>
                                <div className="exNote">{callLog.activityRemarks}</div>
                              </li>
                            ))}

                          </ul>
                        </OffcanvasBody>
                      </Offcanvas>

                      <Offcanvas
                        isOpen={this.state.isFollow}
                        direction="end"
                        toggle={this.toggleFollowCanvas}

                      >
                        <OffcanvasHeader toggle={this.toggleFollowCanvas}>
                          Follow Us
                        </OffcanvasHeader>
                        <OffcanvasBody>
                          <Formik
                            enableReinitialize={true}
                            initialValues={{
                              refId: lead.id,
                              addNote: (this.state && this.state.addNote) || "",
                              nextFollowupDate: new Date(),


                            }}
                            validationSchema={Yup.object().shape({
                              addNote: Yup.string().max(500, 'Only 500 Characters are allowed').required("This is Required")
                            })}

                            onSubmit={values => {

                              if (isEditFollow) {

                                onAddLeadFollowUp(values)

                              } else {

                              }
                              this.toggleFollow();
                            }}
                          >
                            {({ errors, touched, values, handleChange, setFieldValue }) => (
                              <Form
                                className="needs-validation"
                              >

                                <Row>
                                  <Col md="12">
                                    <FormGroup className="mb-3">

                                      <textarea
                                        name="addNote"
                                        onChange={handleChange}
                                        type="textarea"
                                        className={
                                          "form-control" +
                                          (errors.addNote && touched.addNote
                                            ? " is-invalid"
                                            : "")
                                        }
                                        id="addNote"
                                      />
                                      <ErrorMessage
                                        name="addNote"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col md="12">
                                    <FormGroup className="mb15">

                                      <Label htmlFor="logDate">
                                        Date
                                      </Label>
                                      <Flatpickr
                                        className={
                                          "form-control" +
                                          (errors.nextFollowupDate && touched.nextFollowupDate
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder=""
                                        value={values.nextFollowupDate}
                                        onChange={(value) => setFieldValue('nextFollowupDate', value[0])}
                                        options={{
                                          altInput: true,
                                          altFormat: "F j, Y",
                                          dateFormat: "Y-m-d"
                                        }}
                                      />
                                      <ErrorMessage
                                        name="logDate"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>

                                  </Col>
                                </Row>

                                <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                              </Form>
                            )}
                          </Formik>
                          <div className="mb-5 h4 card-title mt-20">Follow-up History</div>
                          <ul className="verti-timeline list-unstyled">

                            {map(leadFollows, (follLog, follLogkey) => (

                              <li className="event-list eventlist" key={"_note_" + follLogkey}>
                                <div className="event-timeline-dot">
                                  <i className="bx bx-right-arrow-circle font-size-18" />
                                </div>
                                <div className="d-flex">
                                  <div className="flex-shrink-0 me-3">
                                    <h5 className="font-size-14">
                                      <Moment format="D MMM YY">{follLog.activityRefStartDate}</Moment>


                                    </h5>
                                  </div>
                                  <div className="flex-grow-1">
                                    <h5 className="font-size-14"></h5>
                                  </div>
                                </div>
                                <div className="exNote">{follLog.activityRemarks}</div>
                              </li>
                            ))}

                          </ul>

                        </OffcanvasBody>
                      </Offcanvas>


                      <Offcanvas
                        isOpen={this.state.isEmailLog}
                        direction="end"
                        toggle={this.toggleEmailLogCanvas}
                        style={{ width: 800 }}
                      >
                        <OffcanvasHeader toggle={this.toggleEmailLogCanvas}>
                          Email Log
                        </OffcanvasHeader>
                        <OffcanvasBody>
                          <Formik
                            enableReinitialize={true}
                            initialValues={{
                              actionType: '',
                              addedDate: new Date(),
                              refId: lead.id

                            }}
                            validationSchema={Yup.object().shape({
                              actionType: Yup.string().required(
                                "Please Select Action"
                              ),
                              remarks: Yup.string().max(500, 'This filed contains only 500 characters only')
                            })}

                            onSubmit={values => {

                              if (isEditCall) {

                                onAddEmailLog(values)
                                //onAddLeadNote(updateData);
                              } else {

                              }
                              this.toggleEmailLog();
                            }}
                          >
                            {({ errors, touched, values, handleChange, setFieldValue }) => (
                              <Form
                                className="needs-validation"
                              >

                                <Row className="mt20 mb20">



                                  <Col lg="12">
                                    <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                                      <label>
                                        <SafeField type="radio" name="actionType" id="actionType1" value="Email Sent" onChange={handleChange} />
                                        Email Sent
                                      </label>
                                      <label>
                                        <SafeField type="radio" name="actionType" id="actionType2" value="Email Received" onChange={handleChange} />
                                        Email Received
                                      </label>
                                      <label>
                                        <SafeField type="radio" name="actionType" id="actionType2" value="Email Bounced" onChange={handleChange} />
                                        Email Bounced
                                      </label>

                                    </div>
                                    <ErrorMessage
                                      name="actionType"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </Col>

                                </Row>
                                <Row>
                                  <Col md="12">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="addedDate">
                                        Log Date
                                      </Label>
                                      <Flatpickr
                                        className={
                                          "form-control" +
                                          (errors.addedDate && touched.addedDate
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder=""
                                        value={values.addedDate}
                                        onChange={(value) => setFieldValue('addedDate', value[0])}
                                        options={{
                                          altInput: true,
                                          altFormat: "F j, Y",
                                          dateFormat: "Y-m-d"
                                        }}
                                      />
                                      <ErrorMessage
                                        name="addedDate"
                                        component="div"
                                        className="invalid-feedback"
                                      />

                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md="12">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="remarks">
                                        Add Message (Optional)
                                      </Label>
                                      <textarea
                                        name="remarks"
                                        onChange={handleChange}
                                        type="textarea"

                                        className="form-control"

                                        id="remarks"

                                      />
                                      <ErrorMessage
                                        name="remarks"
                                        component="div"
                                        className="text-danger"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                              </Form>
                            )}
                          </Formik>
                          <div className="mb-5 h4 card-title mt-20">Email Log History</div>
                          <ul className="verti-timeline list-unstyled">

                            {map(emaillogs, (emailLog, emailkey) => (

                              <li className="event-list eventlist" key={"_email_" + emailkey}>
                                <div className="event-timeline-dot">
                                  <i className="bx bx-right-arrow-circle font-size-18" />
                                </div>
                                <div className="d-flex">
                                  <div className="flex-shrink-0 me-3">
                                    <h5 className="font-size-14">
                                      <Moment format="D MMM YY">{emailLog.addedDate}</Moment>

                                      <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                                    </h5>
                                  </div>
                                  <div className="flex-grow-1">
                                    <h5 className="font-size-14">{localization["ActivitySubType_" + emailLog.activityType + "_" + emailLog.activitySubType]}</h5>
                                  </div>
                                </div>
                                <div className="exNote">{emailLog.activityRemarks}</div>
                              </li>
                            ))}

                          </ul>
                        </OffcanvasBody>
                      </Offcanvas>


                      <Offcanvas
                        isOpen={this.state.isSmsLog}
                        direction="end"
                        toggle={this.toggleSmsLogCanvas}
                        style={{ width: 800 }}
                      >
                        <OffcanvasHeader toggle={this.toggleSmsLogCanvas}>
                          SMS Log
                        </OffcanvasHeader>
                        <OffcanvasBody>
                          <Formik
                            enableReinitialize={true}
                            initialValues={{
                              logDate: new Date(),
                              actionType: (this.state && this.state.actionType) || "",


                            }}
                            validationSchema={Yup.object().shape({
                              actionType: Yup.string().required(
                                "Please Select Action"
                              ),
                              smsNote: Yup.string().max(140, 'This filed contains only 140 characters only')
                            })}

                            onSubmit={this.handleLeadEmailSubmit}
                          >
                            {({ errors, touched, values, handleChange, setFieldValue }) => (
                              <Form
                                className="needs-validation"
                              >

                                <Row className="mt20 mb20">



                                  <Col lg="12">
                                    <div role="group" className="btnCheckGroup" aria-labelledby="my-radio-group">
                                      <label>
                                        <SafeField type="radio" name="actionType" id="actionType1" value="SMS Sent" onChange={handleChange} />
                                        SMS Sent
                                      </label>
                                      <label>
                                        <SafeField type="radio" name="actionType" id="actionType2" value="SMS Received" onChange={handleChange} />
                                        SMS Received
                                      </label>
                                      <label>
                                        <SafeField type="radio" name="actionType" id="actionType2" value="SMS Bounced" onChange={handleChange} />
                                        SMS Bounced
                                      </label>

                                      <ErrorMessage
                                        name="actionType"
                                        component="div"
                                        className="text-danger"
                                      />

                                    </div>

                                  </Col>

                                </Row>
                                <Row>
                                  <Col md="12">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="logDate">
                                        Log Date
                                      </Label>
                                      <Flatpickr
                                        className={
                                          "form-control" +
                                          (errors.logDate && touched.logDate
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder=""
                                        value={values.logDate}
                                        onChange={(value) => setFieldValue('logDate', value[0])}
                                        options={{
                                          altInput: true,
                                          altFormat: "F j, Y",
                                          dateFormat: "Y-m-d"
                                        }}
                                      />
                                      <ErrorMessage
                                        name="logDate"
                                        component="div"
                                        className="invalid-feedback"
                                      />

                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md="12">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="smsNote">
                                        Add Message (Optional)
                                      </Label>
                                      <textarea
                                        name="smsNote"
                                        onChange={handleChange}
                                        type="textarea"

                                        className={
                                          "form-control" +
                                          (errors.smsNote && touched.smsNote
                                            ? " is-invalid"
                                            : "")
                                        }

                                        id="smsNote"

                                      />
                                      <ErrorMessage
                                        name="smsNote"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                              </Form>
                            )}
                          </Formik>
                        </OffcanvasBody>
                      </Offcanvas>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
LeadList.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  gridLoading: PropTypes.object,
  history: PropTypes.object,
  onAddLeadNote: PropTypes.func,
  onGetNoteLead: PropTypes.func,
  leadNotes: PropTypes.array,
  onGetFollowLead: PropTypes.func,
  leadFollows: PropTypes.array,
  onAddLeadFollowUp: PropTypes.func,
  onGetLeadEmailLog: PropTypes.func,
  onGetLeadCallLog: PropTypes.func,
  calllogs: PropTypes.array,
  emaillogs: PropTypes.array,
  onAddCallLog: PropTypes.func,
  onAddEmailLog: PropTypes.func,
  onSendWorksheetEmailLog: PropTypes.func,
  onGetAllActLead: PropTypes.func,
  activities: PropTypes.array,
  onGetAllLeads: PropTypes.func,
  allLeads: PropTypes.array,
  onDeleteLead: PropTypes.func
}
const mapStateToProps = ({ leads,projectleads }) => (

  {
    gridLoading: leads.gridLoading,
    allLeads: leads.allLeads,
    leadNotes: leads.leadNotes,
    activities: leads.activities,
    leadFollows: projectleads.leadFollows,
    calllogs: leads.calllogs,
    emaillogs: leads.emaillogs


  })
const mapDispatchToProps = dispatch => ({


  onGetAllLeads: (agentId) => dispatch(getLeads(agentId)),
  onAddLeadNote: (data) => dispatch(addLeadNoteTab(data)),
  onGetNoteLead: (leadId) => dispatch(getNoteLeadTab(leadId)),
  onGetFollowLead: (leadId) => dispatch(getActivityFollowUp(leadId)),
  onAddLeadFollowUp: (data) => dispatch(addActivityFollowUp(data)),
  onAddCallLog: (data) => dispatch(addLeadCallLog(data)),
  onGetLeadCallLog: (leadId) => dispatch(getLeadCallLog(leadId)),
  onAddEmailLog: (data) => dispatch(addLeadEmailLog(data)),
  onGetLeadEmailLog: (leadId) => dispatch(getLeadEmailLog(leadId)),
  onGetAllActLead: (leadId) => dispatch(getAllActLeadTab(leadId)),
  onDeleteLead: (id) => dispatch(deleteLead(id))

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LeadList))